import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Combina classes CSS de forma inteligente
 * Resolve conflitos do Tailwind e permite condicionais
 *
 * @example
 * cn("text-red-500", "text-blue-500") // => "text-blue-500"
 * cn("p-4", condition && "p-8") // => "p-8" se condition for true
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
